import { User } from '../../../models/User/User.js';

class Users {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  post(user, source) {
    var _this$apiClient$getTe, _user$policies;
    const tenantId = (_this$apiClient$getTe = this.apiClient.getTenant()) === null || _this$apiClient$getTe === void 0 ? void 0 : _this$apiClient$getTe.name;
    if (!tenantId) {
      throw new Error('The user not has a tenant associated, you need to specify a tenant in the api client');
    }
    const payload = {
      email: user.email,
      language: user.language,
      policies: (_user$policies = user.policies) === null || _user$policies === void 0 ? void 0 : _user$policies.getCreatePayload(),
      tenant_id: tenantId
    };
    return this.apiClient.post('com/users/register-anonymous', {
      ...payload,
      source
    }).then(_ref => {
      let {
        data
      } = _ref;
      const {
        client_id,
        email,
        user_id
      } = data;
      return new User(undefined, client_id, email, user_id, undefined, undefined, undefined, undefined);
    });
  }
}

export { Users };
//# sourceMappingURL=Users.js.map
